import { ComponentProps } from 'react';
import { ModelInput } from './ModelInput';

export function ModelPhoneInput(props: ComponentProps<typeof ModelInput>) {
  return (
    <ModelInput
      {...props}
      mutateValue={(v) => {
        const plus = v?.substring(0, 1) === '+' ? '+' : '';
        const numbers = v?.substring(plus ? 1 : 0).replace(/\D/g, '');
        return `${plus}${numbers}`;
      }}
    />
  );
}
